import { ActionType, ActionTypes } from '../../actions/index';
import { cloneDeep, uniq } from 'lodash';
import { ReserveResult } from '../../classes/cart';
import { CartSeat } from '../../classes/seat';
import { IMaxTicketsErrorActionValue } from '../actions/cart-actions';

export interface ICartModel {
    remainingTessituraCartTimer: number;
    seats: Array<CartSeat>;
    removedSeats: Array<CartSeat>;
    reserveResult: ReserveResult;
    reservingSeats: boolean;
    maxPriceTypeTicketQuantityReached: boolean;
    maxSeatingOptionTicketQuantityReached: boolean;

    flexMinQuantityReached: boolean,
    flexMaxQuantityReached: boolean,
    flexMaxQuantityReachedForPriceType: boolean,
    flexTicketQuantityNotReachedError: boolean;
    cartUpdated: boolean;
    cartDisabled: boolean;
    showCartRemovalConfirmPrompt: boolean;
    seatToRemove: CartSeat;
}

let defaultCartModel: ICartModel = {
    remainingTessituraCartTimer: null,
    seats: [],
    removedSeats: [],
    reserveResult: null,
    reservingSeats: false,
    maxPriceTypeTicketQuantityReached: false,
    maxSeatingOptionTicketQuantityReached: false,
    flexMinQuantityReached: false,
    flexMaxQuantityReached: false,
    flexMaxQuantityReachedForPriceType: false,
    flexTicketQuantityNotReachedError: false,
    cartUpdated: false,
    cartDisabled: false,
    showCartRemovalConfirmPrompt: false,
    seatToRemove: null
};

export { defaultCartModel };

export function cartModel(state: ICartModel = defaultCartModel, action): ICartModel {
    switch (action.type) {
        //case ActionTypes.SET_PACKAGE_TICKET_QUANTITIES:
        //    // Default min quantity message if flex ticket quantity exists
        //    return { ...state, flexMinQuantityReached: false}
        case ActionTypes.ADD_SEAT_TO_CART:
            const seats = uniq(state.seats.concat([action.value]));
            return {
                ...state,
                seats,
                cartUpdated: true
            };
        case ActionTypes.SAVE_SEAT_REMOVAL_FROM_CART:
            return { ...state, seatToRemove: action.value };
        case ActionTypes.REMOVE_SEAT_FROM_CART:
            const newSeats = state.seats.filter(seat => {
                return seat.seatId !== action.value.seatId;
            })

            let newRemovedSeats = cloneDeep(state.removedSeats);
            newRemovedSeats.push(action.value);
            return {
                ...state,
                seats: newSeats,
                removedSeats: newRemovedSeats,
                cartUpdated: true
            };
        case ActionTypes.QUICK_CHECKOUT:
            return { ...state, reserveResult: null, reservingSeats: true };
        case ActionTypes.RESERVE_CART:
            return { ...state, reserveResult: null, reservingSeats: true };
        case ActionTypes.GO_TO_FILTERS:
            return { ...state, reserveResult: null, reservingSeats: false };
        case ActionTypes.RECEIVE_RESERVE_RESULT:
            return { ...state, reserveResult: action.value, reservingSeats: false };
        case ActionTypes.MAX_TICKETS_SELECTED:
            let actionValue = action.value as IMaxTicketsErrorActionValue;
            if (!actionValue.isError) {
                return { ...state, maxPriceTypeTicketQuantityReached: action.value.isError, maxSeatingOptionTicketQuantityReached: action.value.isError };
            }
            else if (actionValue.isPriceType) {
                return { ...state, maxPriceTypeTicketQuantityReached: action.value.isError };
            } else {
                return { ...state, maxSeatingOptionTicketQuantityReached: action.value.isError };
            }
        case ActionTypes.FLEX_MIN_SEATS_SELECTED:
            return { ...state, flexMinQuantityReached: action.value };
        case ActionTypes.FLEX_MAX_ALL_SEATS_SELECTED:
            return { ...state, flexMaxQuantityReached: action.value };
        case ActionTypes.FLEX_MAX_SEATS_SELECTED_FOR_PRICETYPE:
            return { ...state, flexMaxQuantityReachedForPriceType: action.value };
        case ActionTypes.FLEX_TICKETS_NOT_SELECTED:
            return { ...state, flexTicketQuantityNotReachedError: action.value };
        case ActionTypes.CART_UPDATED:
            return { ...state, cartUpdated: action.value };
        case ActionTypes.DISABLE_CART:
            return { ...state, cartDisabled: action.value };
        case ActionTypes.SHOW_CART_REMOVAL_MODAL:
            return { ...state, showCartRemovalConfirmPrompt: action.value }
        case ActionTypes.SET_CART_TIMER:
            return { ...state, remainingTessituraCartTimer: action.value }
        default:
            return state;
    }
};